import { render, staticRenderFns } from "./subject-update.vue?vue&type=template&id=44a45e3b&"
import script from "./subject-update.vue?vue&type=script&lang=js&"
export * from "./subject-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports